/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { NotificationManager } from "react-notifications";
import { useDropzone } from "react-dropzone";
import type { ApiResponse, appConfigs, RootState } from "../types/types";
import { HugeiconsIcon } from "@hugeicons/react";
import CustomDataTable from "../CustomDataTable/CustomDataTable";
//@ts-ignore
import { Image02Icon } from "@hugeicons-pro/core-solid-standard";
//@ts-ignore
import { Copy01StrokeStandard } from "@hugeicons-pro/core-stroke-standard";
import { styled } from "@mui/material/styles";
import type { TooltipProps } from "@mui/material/Tooltip";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { Box, IconButton,InputAdornment,LinearProgress,TextField } from "@mui/material";
//@ts-ignore
import { Delete03Icon } from "@hugeicons-pro/core-stroke-standard";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { gettemplateImageList,updatetemplateimages } from 'src/services/templateService';
//@ts-ignore
import {MultiplicationSignStrokeStandard} from '@hugeicons-pro/core-stroke-standard';
import { useSelector } from "react-redux";
import GradientButton from "../MUICustomButton/GradientButton";
import Loader from '../Loader';
import CircularProgress from "@mui/material/CircularProgress";
//@ts-ignore
import { Tick02Icon,Cancel01Icon,ViewStrokeRounded} from "@hugeicons-pro/core-stroke-rounded";

interface PropsType {
  closeModal: () => void;
  imageData: {src: string; alt: string}[];
  onFilesUpload: (files: UploadedFile[]) => void;
  updateEditorContent?: (oldUrl: string, newUrl: string) => void;
  templateIdentifier?:string | null;
  TemplateName?:string | null;
}
interface UploadedFile {
  id: string;
  file?: File;
  preview: string;
  url: string;
  size: string;
}


interface imageDataFile {
  id: string;
  preview: string; 
  url: string; 
  size: string;
  alt: string;
 }
const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props}  classes={{ popper: className }} placement="bottom" />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: { backgroundColor: theme.palette.common.black },
  [`& .${tooltipClasses.arrow}`]: {
    display: "none",
  },
}));
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));
function TemplateImageUpload({ closeModal, imageData, onFilesUpload, updateEditorContent,templateIdentifier,TemplateName  }: PropsType): JSX.Element {
  const [maxFileSize, setMaxFileSize] = useState<number>(0);
  const [maxFileSizeDisplay, setMaxFileSizeDisplay] = useState<number>(0);
  const [allowedExtensions, setAllowedExtensions] = useState<string[]>([]);
  const [allowedMimeTypes, setAllowedMimeTypes] = useState<string[]>([]);
  const [uploadedFiles, setUploadedFiles] = useState<UploadedFile[]>([]);
  const [newImagData, setNewImagData] = useState<imageDataFile[]>([]);
  const [formattedExistingImages, setFormattedExistingImages] = useState<UploadedFile[]>([]);
  const [showImagePreviewModal, setShowImagePreviewModal] = useState<boolean>(false);
  const [previewImageUrl, setPreviewImageUrl] = useState<string>("");
  const [extensionsDisplay, setExtensionsDisplay] = useState<string>("");
  const templateGuid = templateIdentifier ?? localStorage.getItem("templateGuid");
   const { user } = useSelector((state: RootState) => state.auth);
   const [loading, setLoading] = useState<boolean>(true)
   const dataFetchedRef = useRef<boolean>(false);
   const [uploadingFiles, setUploadingFiles] = useState<Record<string, boolean>>({});
   const storedAppConfig = localStorage.getItem("appConfigs");
   const parsedAppConfig = (storedAppConfig != null) ? JSON.parse(storedAppConfig) as appConfigs[] : [];
   const imagePublicUrl = parsedAppConfig.find((item) => item.configName === "TemplateImagePublicURL")?.configValue;
   const [maxFileCount, setMaxFileCount] = useState<number>(Infinity);

// Fetch template images only once when component mounts
useEffect(() => {
  if (templateGuid != null && !dataFetchedRef.current) {
    dataFetchedRef.current = true;
    void getTemplateListData();
  }
}, [templateGuid]);
const getTemplateListData = async (): Promise<void> => {
  if (templateGuid != null) {
    setLoading(true);

    try {
      const createdBy = user?.id ?? 1;
      const res: ApiResponse = await gettemplateImageList(templateGuid, createdBy);

      if (res.status === 200) {
        //@ts-ignore
        const formattedImages: UploadedFile[] = res.data.data.map((item: { imageUrl: string }) => ({
          id: item.imageUrl,
          preview: item.imageUrl,
          url: item.imageUrl,
          size: "",
        }));

        setFormattedExistingImages(formattedImages);
      } else {
        NotificationManager.error("Failed to fetch images");
      }
    } catch (error) {
      console.error("Error fetching images:", error);
      NotificationManager.error("Unknown error has occurred");
    } finally {
      setLoading(false); // ✅ Hide Loader after fetching
    }
  }
};


  useEffect(() => {
    onFilesUpload(uploadedFiles);
  }, [uploadedFiles, onFilesUpload]);

  useEffect(() => {
    const storedAppConfig = localStorage.getItem("appConfigs");
    if (storedAppConfig != null) {
      try {
        const parsedAppConfig = JSON.parse(storedAppConfig) as appConfigs[];

        const maxSize = parsedAppConfig.find((item) => item.configName === "TemplateMaxFileSize")?.configValue;
        const extensions = parsedAppConfig.find((item) => item.configName === "TemplateImageAllowedExtensions")?.configValue;
        const mimeTypes = parsedAppConfig.find((item) => item.configName === "TemplateImageAllowedMimeTypes")?.configValue;
        const maximumImageCount = parsedAppConfig.find((item) => item.configName === "TemplateImageFileCount")?.configValue;
        const MaxFileSizeDisplay = maxSize != null ? Math.round(parseInt(maxSize) / 1024 / 1024) : 0;
        const maxFileCount = parsedAppConfig.find((item) => item.configName === "TemplateImageFileCount")?.configValue;

        setMaxFileSizeDisplay(MaxFileSizeDisplay);
        if(extensions != undefined || extensions != null){
          setExtensionsDisplay(extensions);
        }
       
        if (maxSize != null) setMaxFileSize(parseInt(maxSize, 10) * 1024); // Convert KB to Bytes
        if (extensions != null)
          setAllowedExtensions(extensions.split(",").map((ext) => ext.trim().toLowerCase().replace(/^\./, "")));
        if (mimeTypes != null) setAllowedMimeTypes(mimeTypes.split(",").map((mime) => mime.trim().toLowerCase()));
        if (maxFileCount != null) setMaxFileCount(parseInt(maxFileCount, 10));
      } catch (error) {
        console.error("Error parsing appConfig data:", error);
      }
    }

    // Transform `imageData` to `newImagData` for display only
    const transformedImages = imageData.map((img) => {
      const filename = img.src.split("/").pop();
      return {
        id: `${filename}-${Date.now()}`,
        preview: img.src,
        url: img.src,
        size: "0 MB",
        alt: img.alt 
      };
    });
    setNewImagData(transformedImages);
  }, []);

  
  const mergedFiles = React.useMemo(() => {
    const existingFilesMap = new Map();
  
    formattedExistingImages.forEach((file) => existingFilesMap.set(file.id, file));
    uploadedFiles.forEach((file) => {
      if (!existingFilesMap.has(file.id)) {
        existingFilesMap.set(file.id, file);
      }
    });
  
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return Array.from(existingFilesMap.values()); // ✅ Ensure files are not removed after upload
  }, [formattedExistingImages, uploadedFiles]);
  

  const onDrop = useCallback(
    async (acceptedFiles: File[]) => {
      const newFiles: UploadedFile[] = [];
      const errorMessages: string[] = [];
      
      // Check if too many files are selected
      if (acceptedFiles.length > maxFileCount) {
        NotificationManager.error(`You can only upload up to ${maxFileCount} files at a time.`);
        return;
      }
      
      // Debug logs - show which extensions are allowed
      console.log("Allowed extensions:", allowedExtensions);
      console.log("Files being processed:", acceptedFiles.map(f => ({ name: f.name, type: f.type })));
      
      acceptedFiles.forEach((file) => {
        const fileSizeValid = file.size <= maxFileSize;
        const fileExtension = file.name.split(".").pop()?.toLowerCase() ?? "";
        const fileMimeType = file.type.toLowerCase();
        const fileExtensionValid = allowedExtensions.includes(fileExtension);
        const fileMimeTypeValid = allowedMimeTypes.includes(fileMimeType);
        
        console.log(`File validation for ${file.name}:`, {
          extension: fileExtension,
          mime: fileMimeType,
          sizeValid: fileSizeValid,
          extensionValid: fileExtensionValid,
          mimeValid: fileMimeTypeValid
        });
        
        // Always collect validation errors for notification
        if (!fileSizeValid) {
          errorMessages.push(`${file.name} exceeds the max file size limit of ${(maxFileSize / (1024 * 1024)).toFixed(2)} MB.`);
        }
        if (!fileExtensionValid) {
          errorMessages.push(`${file.name} has an invalid file extension. Allowed: ${allowedExtensions.join(", ")}.`);
        }
        if (!fileMimeTypeValid) {
          errorMessages.push(`${file.name} has an invalid MIME type. Allowed: ${allowedMimeTypes.join(", ")}.`);
        }
  
        // Only add valid files to newFiles
        if (fileSizeValid && fileExtensionValid && fileMimeTypeValid) {
          const newFile: UploadedFile = {
            id: `${file.name}-${Date.now()}`,
            file,
            preview: URL.createObjectURL(file),
            url: `${file.name}`,
            size: `${(file.size / (1024 * 1024)).toFixed(2)} MB`,
          };
  
          newFiles.push(newFile);
        }
      });
  
      // Show ALL error messages (even if some files are valid)
      if (errorMessages.length > 0) {
        console.log("Validation errors:", errorMessages);
        errorMessages.forEach((error) => {
          NotificationManager.error(error, "Validation Error", 5000);
        });
      }
  
      // Continue only if we have valid files
      if (newFiles.length === 0) {
        if (errorMessages.length === 0) {
          // This shouldn't happen normally, but just in case
          NotificationManager.error("No valid files to upload.", "Warning", 3000);
        }
        return;
      }
  
      // Upload valid files
      const newUploadingState = newFiles.reduce((acc, file) => {
        acc[file.id] = true;
        return acc;
      }, {} as Record<string, boolean>);
  
      setUploadingFiles((prev) => ({ ...prev, ...newUploadingState }));
      setUploadedFiles((prevFiles) => [...prevFiles, ...newFiles]);
  
      // Call the upload function after file selection
      handleUploadClick(newFiles).catch((err) => {
        console.error("Upload failed:", err);
        NotificationManager.error("Failed to upload files. Please try again.", "Upload Error", 5000);
      });
    },
    [maxFileSize, allowedExtensions, allowedMimeTypes, uploadedFiles, maxFileCount]
  );
  

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    onDrop,
    accept: allowedMimeTypes.length > 0 
      ? allowedMimeTypes.reduce((acc, mime) => ({ ...acc, [mime]: [] }), {})
      : undefined, // Fall back to accepting all files if no mimes specified
    multiple: true,
    noClick: false,
    noKeyboard: false,
    preventDropOnDocument: true,
    // Override the default validator to catch files earlier
    validator: (file) => {
      const fileExtension = file.name.split(".").pop()?.toLowerCase() ?? "";
      const fileMimeType = file.type.toLowerCase();
      
      if (!allowedExtensions.includes(fileExtension)) {
        return {
          code: "file-invalid-type",
          message: `File type .${fileExtension} is not accepted`
        };
      }
      
      if (!allowedMimeTypes.includes(fileMimeType)) {
        return {
          code: "file-invalid-type",
          message: `MIME type ${fileMimeType} is not accepted`
        };
      }
      
      if (file.size > maxFileSize) {
        return {
          code: "file-too-large",
          message: `File is larger than ${(maxFileSize / (1024 * 1024)).toFixed(2)} MB`
        };
      }
      
      return null;
    }
  });

const handleImagePreviewShow = (url: string): void =>{
  setShowImagePreviewModal(true);
  setPreviewImageUrl(url);
}
const handleImagePreviewClose = (): void =>{
  setShowImagePreviewModal(false);
  setPreviewImageUrl("");
}
const handleUploadClick = async (files: UploadedFile[]): Promise<void> => {
  console.log(1122222);
  console.log(files);
  if (files.length === 0) {
    NotificationManager.error("No files to upload.");
    return;
  }

  // ✅ Ensure single-upload file limit is respected
  if (files.length > maxFileCount) {
    NotificationManager.error(`You can only upload up to ${maxFileCount} images per upload.`);
    return;
  }

  for (const file of files) {
    if (!file.file) continue;

    setUploadingFiles((prev) => ({ ...prev, [file.id]: true }));

    const formData = new FormData();
    formData.append("templateImages", file.file, file.file.name);

    try {
      const response = await updatetemplateimages(formData, templateGuid ?? "", user?.id ?? 1);

      if (response.status === 200) {
        const uploadedFileName = file.file.name;
        const uploadedUrl = `${imagePublicUrl}Template/${templateGuid}/${uploadedFileName}`;

        setFormattedExistingImages((prev) =>
          prev.map((existingFile) =>
            existingFile.id === file.id
              ? { ...existingFile, url: uploadedUrl, preview: uploadedUrl }
              : existingFile
          )
        );

        setFormattedExistingImages((prev) => {
          const isFileExisting = prev.some((existingFile) => existingFile.id === file.id);
          return isFileExisting ? prev : [...prev, { ...file, url: uploadedUrl, preview: uploadedUrl }];
        });
      }
    } catch (error) {
      console.error("Upload error:", error);
      NotificationManager.error(`Error uploading ${file.file.name}.`);
    } finally {
      setUploadingFiles((prev) => ({ ...prev, [file.id]: false }));
    }
  }

  setUploadedFiles([]);
};



  const columns = [
    {
      name: "Image",
      selector: (row: UploadedFile) => row.preview,
      cell: (row: UploadedFile) => (
        <div style={{ position: "relative", width: "50px", height: "50px" }}>
            <BootstrapTooltip title={row.url} >
              <span>
          <div
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              background: uploadingFiles[row.id] ? "rgba(255,255,255,0.5)" : "transparent", // ✅ Dim background when uploading
              zIndex: 1,
            }}
          />
          
          {uploadingFiles[row.id] && (
            <div
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 2, // ✅ Ensure loader is in front
              }}
            >
              <CircularProgress size={30} thickness={5} sx={{ color: '#ED4B52' }} />
            </div>
          )}
    
          <img
            src={row.preview}
            alt="preview"
            className="w-10 h-10 object-cover rounded-md"
            style={{
              opacity: uploadingFiles[row.id] ? 0.5 : 1, // ✅ Dim the image if it's uploading
            }}
          />
</span>
          </BootstrapTooltip>
        </div>
      ),
      width: "20%",
    },  
    {
      name: "URL",
      selector: (row: UploadedFile) => row.url,
      cell: (row: UploadedFile) =>  {
        const [tooltipText, setTooltipText] = useState("Copy");
  
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        const handleCopyToken = (token: string) => {
          // eslint-disable-next-line @typescript-eslint/no-floating-promises
          navigator.clipboard.writeText(token);
          setTooltipText("Copied!"); // Change tooltip to "Copied!"
          setTimeout(() => setTooltipText("Copy"), 1500); // Reset after 1.5s
        }; 
        return (
          <div className="flex items-center" >
        <a   target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline truncate block  max-w-[300px]  text-[#3A3A3A]">
          {row.url}
          </a>
          <div className="icon-hover-container" >
          <BootstrapTooltip title={tooltipText} >
                    <IconButton
                      onClick={() => handleCopyToken(row.url)}
                    >                      
                      <HugeiconsIcon
                      icon={Copy01StrokeStandard}
                      size={20}
                      color="currentcolor"
                      strokeWidth={0.2}
                      /> 
      
                    </IconButton>
                  </BootstrapTooltip>
                  </div>
       </div>
      )
    },
      wrap: true,
      width: "60%",
    },
    {
      name: "Size",
      selector: (row: UploadedFile) => row.size,
      cell: (row: UploadedFile) => <span className="text-gray-600">{(row.size !== "") && row.size !== "Unknown Size" ? row.size : ''}</span>,
      width: "20%",
    },
   
  ];
  const imageDatacolumns = [
    {
      name: "Image",
      cell: (row: imageDataFile) => {
        const [imageError, setImageError] = useState(false);
  
        return (
          <div style={{ position: "relative", width: "50px", height: "50px" }}
            onClick={(row.url !== "") ? () => handleImagePreviewShow(row.url) : undefined}
          >
             <BootstrapTooltip title={row.url} >
             <span>
            {!imageError && (row.preview !== "") ? (
              <img
                src={row.preview}
                alt={row.alt}
                width={90}
                height={90}
                className="icon-hover"
                onError={(e) => {
                  setImageError(true);
                  e.currentTarget.style.display = 'none';
                  const iconElement = e.currentTarget.nextElementSibling as HTMLElement;
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  if (iconElement) iconElement.style.display = 'flex';
                }}
                style={{ borderRadius: '8px', objectFit: 'cover' }}
              />
            ) : null}
  
            <HugeiconsIcon
              icon={Image02Icon}
              size={24}
              color="#6B7280"
              className="hidden"
            />
  
            <div
              className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 rounded-lg hover:opacity-100 transition-opacity cursor-pointer"
            >
              <HugeiconsIcon
                icon={ViewStrokeRounded}
                size={24}
                color="white"
                strokeWidth={0.5}
                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                className={`cursor-pointer ${!row.url ? 'opacity-50 cursor-not-allowed' : ''}`}
              />
            </div>
            </span>
            </BootstrapTooltip>
          </div>
        );
      },
      width: "20%",
    },
    {
      name: "URL",
      selector: (row: imageDataFile) => row.url,
      cell: (row: imageDataFile) => {
        const [tooltipText, setTooltipText] = useState("Copy");
        const [isEditing, setIsEditing] = useState(false);
        const [tempUrl, setTempUrl] = useState(row.url);
        const [isError, setIsError] = useState(false); // 🔴 Add error state
        
        const handleEdit = (): void => {
          setIsEditing(true);
          setIsError(false); // Reset error when editing starts
        };
        
        const handleCancel = (): void => {
          setIsEditing(false);
          setTempUrl(row.url);
          setIsError(false); // Reset error on cancel
        };
        
        const handleSave = (): void => {
          if (tempUrl.trim() === "") {
            setIsError(true); // Show red background
            NotificationManager.error("Please provide a valid URL");
            return;
          }
        
          setIsEditing(false);
          const oldUrl = row.url;
        
          // Update both the URL and preview in the newImagData state
          setNewImagData((prevData) =>
            prevData.map((item) =>
              item.id === row.id ? { ...item, url: tempUrl, preview: tempUrl } : item
            )
          );
        
          // Update the content in the editor
          if (updateEditorContent) {
            updateEditorContent(oldUrl, tempUrl);
          }
        };
        
        // Rest of your component remains the same
        return (
          <div className="flex items-center">
            {isEditing ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  width: "100%",
                }}
              >
                <TextField
                  fullWidth
                  autoComplete="off"
                  label="URL*"
                  placeholder="Enter new URL"
                  value={tempUrl}
                  onChange={(e) => {
                    setTempUrl(e.target.value);
                    setIsError(false); // Reset error when typing
                  }}
                  inputProps={{ maxLength: 500 }}
                  sx={{
                    flex: 1.5,
                    minWidth: "280px",
                    backgroundColor: isError ? "#FFEBEE" : "white"
                  }}
                  error={isError} 
                />
         <BootstrapTooltip title={"Save"} >
                <IconButton onClick={handleSave} sx={{  "&:hover": { color: "#06A864" }  }} className="ml-1">
                  <HugeiconsIcon icon={Tick02Icon} size={20} strokeWidth={0.2} />
                </IconButton>
                </BootstrapTooltip>
                
                <BootstrapTooltip title={"Cancel"} >
                <IconButton onClick={handleCancel} sx={{ "&:hover": { color: "#ED4B52"  }}}>
                  <HugeiconsIcon icon={Cancel01Icon} size={20} strokeWidth={0.2}  />
                </IconButton>
                </BootstrapTooltip>
               
              </div>
            ) : (
              <>
                <a
                  href={row.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline truncate block max-w-[320px]  text-[#3A3A3A]"
                >
                  {row.url}
                </a>
                <div className="icon-hover-container" >
                <BootstrapTooltip title={"Edit"} >
                <div onClick={handleEdit} >
                  <img src="/assets/images/icons/EditIcon.svg" width={18} height={18} alt="Edit" />
                </div>
                </BootstrapTooltip>
                </div>
              </>
            )}
          </div>
        );
        
      },
      wrap: true,
      width: "60%",
    },
    {
      name: "Alt Text",
      selector: (row: imageDataFile) => row.alt,
      cell: (row: imageDataFile) => (
        <span className="text-gray-600 truncate max-w-[120px]">{row.alt }</span>
      ),
      width: "20%",
    }
  ];
  console.log(mergedFiles);
  console.log(loading);
  return (
    <React.Fragment>
      
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="relative px-[16px] pt-[10px]">
            <div className={`mb-[5px] w-full relative role-input-container disabled`} style={{ marginBottom: '30px' }}>
                                  <TextField
                                      id="outlined-basic"
                                      label={"Template Name"}
                                      variant="outlined"
                                      fullWidth
                                      value={TemplateName}
                                      autoComplete="off"
                                      InputProps={{
                                          style: {
                                              textAlign: "center",
                                              color: '#343434 !important',
                                              fontSize: '18px !important',
                                              fontWeight: '700 !important',
                                              WebkitTextFillColor: '#343434 !important',
                                              padding: '9px 14px 9px 25px'
                                          },
                                         
                                      }}
                                      sx={{
                                          '& input': {
                                              textAlign: 'center',
                                          },
                                          '& label': {
                                              textAlign: 'center',
                                          },
                                          backgroundColor: '#F5F5F5',
                                      }}
                                      disabled={true}
                                  />
                                  
                              </div>
                            


          {/* Drag and Drop Zone */}
          <div className="mb-[30px]">
            <div {...getRootProps({ className: "dropzone border-2 border-dashed p-6 text-center cursor-pointer" })}>
              <input {...getInputProps()} />
              {isDragActive ? <p>Drop the files here ...</p> : 
              <> <p>
                                 <span style={{ fontWeight: 600 }}>Drag and drop or</span>
                                    <span
                                      style={{
                                        color: '#007bff',
                                        cursor: 'pointer',
                                        fontWeight: 600,
                                      }}
                                    >
                                      {' '}
                                      Click here{' '}
                                    </span>
                                    <span style={{ fontWeight: 600 }}>to choose file</span>
                                  </p>

                                  <span
                                    style={{
                                      display: 'block',
                                      marginTop: '20px',
                                      fontSize: '12px',
                                      color: '#555'
                                    }}
                                  >
                                    { `Max size: ${maxFileSizeDisplay} MB. `}{' '}
                                    File format: {extensionsDisplay}
                                  </span>
                                  </>
                                  }
            </div>
          </div>
          {loading && (
      <div style={{ padding: '24px' }}>
      <div className='flex justify-center items-center relative top-[50%]'><span className="loading loading-spinner text-primary"></span></div>
    </div>
    )}
          {/* Uploaded Files Preview */}
          {!loading &&mergedFiles.length > 0 && (
            <div className="mb-[30px]">
              
              <div className="flex justify-between items-center mb-2 ">
      <h3 className="text-lg font-semibold text-[#3A3A3A]">Uploaded Images</h3>
    </div>
    <div className="border rounded-lg bg-white p-2" style={{ borderColor: '#E6ECF2' }}>
            <CustomDataTable
              columns={columns}
              data = {[...mergedFiles].reverse()} 
              selectableRows={false}
              pagination
              paginationPerPage={5}
              paginationRowsPerPageOptions={[5, 10, 15, 20, 25,30]}
            />
           </div>
            </div>
          )}
          
          {/* Display Existing Images (`newImagData`) */}
          {newImagData.length > 0 && (
            <div className="mb-[30px]">
              <h3 className="text-lg  mb-2 font-semibold text-[#3A3A3A]">External Images</h3>
              <div className="border rounded-lg bg-white p-2" style={{ borderColor: '#E6ECF2' }}>
                <CustomDataTable
                  columns={imageDatacolumns}
                  data={newImagData}
                  selectableRows={false}
                  pagination
                  paginationPerPage={5}
                  paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
                />
              </div>
            </div>
          )}
        </div>
      </form>
      <BootstrapDialog 
  onClose={handleImagePreviewClose} 
  aria-labelledby="customized-dialog-title" 
  open={showImagePreviewModal} 
  PaperProps={{  
    sx: {
      width: '75vw', // 75% of viewport width
      height: 'auto', // Auto height to accommodate content
      maxHeight: '75vh', // Max 75% of viewport height
      position: 'absolute',
      top: '10%' // Position higher on the screen
    },
  }}
>
  <DialogTitle sx={{ 
    m: 0, 
    p: 1.5,
    color: '#3A3A3A', 
    fontSize: '18px', 
    fontWeight: '600' 
  }} id="customized-dialog-title">
    {"Image Preview"}
  </DialogTitle>
  <IconButton 
    aria-label="close" 
    onClick={handleImagePreviewClose} 
    sx={{
      position: 'absolute',
      right: 8,
      top: 8,
      color: (theme) => theme.palette.grey[500],
    }}
  >
    <HugeiconsIcon
      icon={MultiplicationSignStrokeStandard}
      size={24}
      color="currentcolor"
      strokeWidth={0.5}
    /> 
  </IconButton>
  <DialogContent sx={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    overflow: 'hidden',
    pt: 0,
    pb: 2
  }}>
    {previewImageUrl !='' && (
      <img 
        src={previewImageUrl} 
        alt="Preview" 
        style={{ 
          maxWidth: '100%', 
          maxHeight: '100%',
          objectFit: 'contain' // Ensures image fits within container
        }} 
      />
    )}
  </DialogContent>
</BootstrapDialog>

    </React.Fragment>
  );
}

export default TemplateImageUpload;
